
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import FeaturedCollections from './components/FeaturedCollections';
import ChildrenGifts from './components/ChildrenGifts';
import PartyBags from './components/PartyBags';
import BrandStory from './components/BrandStory';
import Testimonial from './components/Testimonial';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    // Clean up the listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#E2D9CA]">
      <Navigation scrolled={scrolled} />
      <Hero />
      <FeaturedCollections />
      <ChildrenGifts />
      <PartyBags />
      <BrandStory />
      <Testimonial />
      <CallToAction />
      <Footer />
    </div>
  );
}
